App.Modules.Panel.Default = class DefaultPanel extends App.Modules.Panel {

    static get options() {
        return {};
    }

    get template() {
        // language=HTML
        return `
			<div id="panel" class="panel panel-left panel-cover">

				<div class="navbar">
					<div class="navbar-bg"></div>
					<div class="navbar-inner" pf="navbarInner">
						<div class="left">
							<a href="#" class="link " pf="menuButton">
								<i class="material-icons">menu</i>
							</a>
						</div>
						<div class="center">Статистика по эмоциям</div>
					</div>
				</div>
				
				<div class="list">

				</div>
			</div>
		`;
    }

    init() {
        super.init();
        console.log('test panel init');
    }

};